export default __webpack_public_path__ + "efe9a7c177e42e5863cb08956edcd03f.pdf";